var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-pagination", {
    staticClass: "products-view__pagination justify-content-center",
    attrs: {
      pills: "",
      "total-rows": _vm.pagination.totalRows,
      "per-page": _vm.pagination.perPage,
      size: "sm"
    },
    on: { change: _vm.onPageChanged },
    model: {
      value: _vm.pagination.currentPage,
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }